import React from 'react';
import { Button, Icon, Table, Form, Header, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle, HeaderCursor } from './css';
import Filters from './Filters';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoCurrentGradesMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesMessage" /></p>;
const NoCurrentGradesFilterMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesFilterMessage" /></p>;

export default class StudentsWithoutGradesCommitteeExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grade: '',

            grading: false,

            showStudentInfo: false,
            studentId: '',
            sspId: '',
            studyProgramId: '',
            finishGrading: this.props.finishGrading

        };

        this.handleGradeChange = this.handleGradeChange.bind(this);
        this.confirmGrade = this.confirmGrade.bind(this);
        this.cancel = this.cancel.bind(this);
    }


    handleGradeChange({ value }, index) {
        this.setState({ grading: true, grade: value, showGradesMode: index });
    }

    cancel(index) {
        if (this.state.showGradesMode === index) {
            this.setState({ grading: false, showGradesMode: null, grade: '' });
        }
    }


    confirmGrade(studentGradedActivityId, markId) {
        let obj = {
            id: studentGradedActivityId,
            gradedActivity: { id: localStorage.getItem('gradedActivityId') },
            mark: { id: markId }
        };
        axios.post('grade-student/committee', { ...obj })
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentGraded" />);

                this.setState({ grading: false, showGradesMode: null, grade: '' });
                this.props.getAllStudents();
            })
            .catch(err => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentGradedFailed" />);
            });

        this.setState({ finishGrading: true });
    }


    render() {
        return (
            <div>
                {this.props.data.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <FormattedMessage id="common.index" />
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id="common.lastName" />
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id="common.firstName" />
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    <FormattedMessage id="professorInputGrades.studyProgram" />
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    <FormattedMessage id="common.grade" />
                                </Table.HeaderCell>
                                <Table.HeaderCell  />
                                <Table.HeaderCell colSpan="2" />

                            </Table.Row>
                        </Table.Header>
                        <Table.Body> { this.props.data.map((el) =>
                            (<Table.Row>
                                <Table.Cell verticalAlign="middle">
                                    {el.index}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.lastName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.firstName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.studyProgramBasicName ? el.studyProgramBasicName : el.departments ? el.departments.map(e => <div>{e.name}</div>) : el.studyProgramName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.markName ? el.markName : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">

                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                        value={this.state.grade}
                                        onChange={(e, event) => this.handleGradeChange(event, el.index)}
                                        name="grade"
                                        options={this.props.marks.filter(e => e.key_ !== 'nz' && e.key_ !== 'no' && e.key_ !== 'nonp' && e.key_ !== 'f')}
                                        search
                                        fluid
                                    />

                                </Table.Cell>

                                <Table.Cell textAlign="center" verticalAlign="middle" colSpan="2">
                                    <Button
                                        color="blue"
                                        size="small"
                                        basic
                                        onClick={
                                            () => {
                                                this.confirmGrade(el.studentGradedActivityId, this.state.grade);
                                            }
                                        }
                                    >  <FormattedMessage id="professorInputGrades.confirmGrade" />
                                    </Button>
                                    <Button
                                        basic
                                        color="red"
                                        size="small"
                                        onClick={() => this.cancel(el.index)}
                                    >   <FormattedMessage id="common.cancelO" />
                                    </Button>
                                </Table.Cell>
                            </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>

                    : <NoCurrentGradesMessage />

                }
                <ToastContainer hideProgressBar />

            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentsWithoutGradesCommitteeExam.js